export default "__VITE_PUBLIC_ASSET__d1318e4a__"